/**
 * The Audience Segmentation tour. Each step points at an element marked
 * `data-tour="<target>"`; steps whose element is not on the page (for
 * example the shortcut buttons when the header is hidden) are skipped.
 *
 * placement: where the card sits next to the element (default: below or
 * above, whichever has room). fab: the shortcut buttons must be open.
 */
export const TOUR_STEPS = [
  {
    target: 'header',
    title: 'Welcome to Smart Segmentation',
    text:
      'This tour walks through every part of the dashboard, top to bottom. ' +
      'Use Next to move on, Back to go back, or Esc to leave at any time.',
  },
  {
    target: 'segments',
    title: 'Your segments',
    text:
      'Every listener is placed in one behavioural segment, such as Super fans or At risk, ' +
      'from how recently and how often they engage. Click a card to filter the whole ' +
      'dashboard to that segment. The green and red arrows show how many listeners moved in ' +
      'and out in the last 7 days (hover "Changed" for the date of the last move), and ' +
      'the refresh button reloads the latest data.',
  },
  {
    target: 'distribution',
    title: 'Segment distribution',
    text: 'The share of your audience in each segment, at a glance.',
  },
  {
    target: 'breakdown',
    title: 'Segment insights',
    text:
      'A closer look at each segment. Open one to see who is in it, how its listeners moved ' +
      'between segments over the last 7 days, and an AI reading with a Return Outlook ' +
      '(uses AI credits, saved for 24 hours).',
  },
  {
    target: 'profiles',
    title: 'Engaged audience profiles',
    text:
      'The make-up of your current audience: gender, age, language, location and more. ' +
      'It follows whatever filters you apply.',
  },
  {
    target: 'cross-channel',
    title: 'Cross platform engagement',
    text:
      'Which channels your listeners use together. Click a pair, such as WhatsApp and SMS, ' +
      'to export the listeners who are active on both.',
  },
  {
    target: 'completeness',
    title: 'Profile completeness',
    text:
      'How complete listener profiles are, and which details are missing most, so you know ' +
      'what to collect next (for example through a survey).',
  },
  {
    target: 'listeners',
    title: 'Listener retargeting',
    text:
      'The listeners behind the numbers. Open any listener for their full profile. Their ' +
      'interests and product affinities appear without any AI credits, marked "From ' +
      'activity", and AI Enrichment adds more, marked "AI-enriched", with return outlook, ' +
      'risk and confidence. From here you can run AI Enrichment for many listeners, Retarget ' +
      'them, or Export them. Listeners who have not given permission or opted in are left ' +
      'out unless you choose to include them.',
  },
  {
    target: 'recommender',
    title: 'Campaign recommender',
    text:
      'Paste an advertiser brief and the AI recommends who to target, on which channels and ' +
      'when, from your real audience data.',
  },
  {
    target: 'fab-filters',
    title: 'Filters',
    placement: 'left',
    fab: true,
    text:
      'Refine the whole dashboard by segment, demographics, channels, activity, consent and ' +
      'more. The badge shows how many filters are active.',
  },
  {
    target: 'fab-find',
    title: 'Find listeners',
    placement: 'left',
    fab: true,
    text:
      'Search by name, number or handle, or describe who you want in plain English and let ' +
      'the AI turn it into filters.',
  },
  {
    target: 'fab-audiences',
    title: 'Audiences',
    placement: 'left',
    fab: true,
    text:
      'Save a group of listeners by describing them in words. Audiences stay up to date ' +
      'every night for free, and you can view, refresh or retarget them.',
  },
  {
    target: 'fab-advertiser',
    title: 'Advertiser hub',
    placement: 'left',
    fab: true,
    text:
      'Prepare and prove a campaign for an advertiser in five tabs: who is ready to respond, ' +
      'when to send, whether it worked, a report to hand over, and how earlier advice turned ' +
      'out. Set your filters first. The first four tabs follow them.',
  },
  {
    target: 'fab-bucket',
    title: 'Retargeting bucket',
    placement: 'left',
    fab: true,
    text:
      'Everything you set aside to retarget, grouped by where it came from. Export it all, ' +
      'or by channel, with the columns you pick.',
  },
  {
    target: 'fab-ai-usage',
    title: 'AI usage',
    placement: 'left',
    fab: true,
    text:
      'Your AI credit balance, what is using it and when it was topped up. Its colour tells ' +
      'you at a glance when credit is running low, and it shows any monthly limit Colony ' +
      'has set for a feature.',
  },
  {
    target: 'fab-toggle',
    title: 'Show or hide shortcuts',
    placement: 'left',
    text:
      'Hide the shortcut buttons when they are in the way, and bring them back here. ' +
      'That is the tour. You can run it again any time from "Take a tour".',
  },
];

export default TOUR_STEPS;



// WEBPACK FOOTER //
// ./src/components/segmentation/utils/tourSteps.js